import { PremiumPreviewType, PremiumPreviewStatus } from '../store/schema/PremiumPreviewData';
import { assertNever } from 'owa-assert';

// URLs
export const URL_TIME_BASED_NEW_CALLOUT = 'https://go.microsoft.com/fwlink/?linkid=2146723';
export const URL_TIME_BASED_ACTIVE_CALLOUT = 'https://go.microsoft.com/fwlink/?linkid=2146721';
export const URL_TIME_BASED_EXPIRED_CALLOUT = 'https://go.microsoft.com/fwlink/?linkid=2146728';

export const URL_TIME_BASED_CONTEXUAL_CARD = 'https://go.microsoft.com/fwlink/?linkid=2147013';

export const URL_COUNT_BASED_NEW_CALLOUT = 'https://go.microsoft.com/fwlink/?linkid=2146724';
export const URL_COUNT_BASED_ACTIVE_CALLOUT = 'https://go.microsoft.com/fwlink/?linkid=2147012';
export const URL_COUNT_BASED_EXPIRED_CALLOUT = 'https://go.microsoft.com/fwlink/?linkid=2147014';

export const URL_COUNT_BASED__CONTEXUAL_CARD = 'https://go.microsoft.com/fwlink/?linkid=2146726';

export const URL_BASIC_SKITTLE_CALLOUT = 'https://go.microsoft.com/fwlink/?linkid=2139290';
export const URL_BASIC_SKITTLE_CONTEXUAL_CARD_SPELLING =
    'https://go.microsoft.com/fwlink/?linkid=2145120';
export const URL_BASIC_SKITTLE_CONTEXUAL_CARD_GRAMMAR =
    'https://go.microsoft.com/fwlink/?linkid=2145204';

export const URL_CONTROL_CONTEXUAL_CARD_SPELLING =
    'https://go.microsoft.com/fwlink/?linkid=2125009';
export const URL_CONTROL_CONTEXUAL_CARD_GRAMMAR = 'https://go.microsoft.com/fwlink/?linkid=2125008';

export const URL_COMBO_NEW_CALLOUT = 'https://go.microsoft.com/fwlink/?linkid=2146725';
export const URL_COMBO_ACTIVE_CALLOUT = 'https://go.microsoft.com/fwlink/?linkid=2146722';
export const URL_COMBO_EXPIRED_CALLOUT = 'https://go.microsoft.com/fwlink/?linkid=2146729';
export const URL_COMBO_CONTEXUAL_CARD = 'https://go.microsoft.com/fwlink/?linkid=2146727';

type CurrentUI = 'Callout' | 'ContexualCard';

export function openGoPremiumUrl(
    premiumPreviewType: PremiumPreviewType,
    premiumPreviewStatus: PremiumPreviewStatus,
    currentUI: CurrentUI
) {
    const goPremiumUrl: string = getGoPremiumUrl(
        premiumPreviewType,
        premiumPreviewStatus,
        currentUI,
        undefined /*isSpelling */
    );
    window.open(goPremiumUrl, '_blank');
}

/**
 * This function returns the needed URL when user click on 'go premium' button
 * based on 3 things :
 * different experiment : count based, date based, combo, Skittle , None
 * status of the user: new , activated, expired
 * Which UI the user clicked: callout or contexual card
 * isSpelling - is used only for old behaviour (Control and Skittle) and once we remove those, it's safe to remove it.
 */
export function getGoPremiumUrl(
    premiumPreviewType: PremiumPreviewType,
    premiumPreviewStatus: PremiumPreviewStatus,
    currentUI: CurrentUI,
    isSpelling: boolean
): string {
    switch (premiumPreviewType) {
        case PremiumPreviewType.TimeBased:
            switch (premiumPreviewStatus) {
                case PremiumPreviewStatus.New:
                    switch (currentUI) {
                        case 'Callout':
                            return URL_TIME_BASED_NEW_CALLOUT;
                        case 'ContexualCard':
                            return URL_TIME_BASED_CONTEXUAL_CARD;
                        default:
                            assertNever(currentUI);
                    }
                    break;

                case PremiumPreviewStatus.Activated:
                    switch (currentUI) {
                        case 'Callout':
                            return URL_TIME_BASED_ACTIVE_CALLOUT;
                        case 'ContexualCard':
                            return URL_TIME_BASED_CONTEXUAL_CARD;
                        default:
                            assertNever(currentUI);
                    }
                    break;

                case PremiumPreviewStatus.Expired:
                    switch (currentUI) {
                        case 'Callout':
                            return URL_TIME_BASED_EXPIRED_CALLOUT;
                        case 'ContexualCard':
                            return URL_TIME_BASED_CONTEXUAL_CARD;
                        default:
                            assertNever(currentUI);
                    }
                    break;

                case PremiumPreviewStatus.Unknown:
                    break;

                default:
                    assertNever(premiumPreviewStatus);
            }
            break;
        case PremiumPreviewType.CountBased:
            switch (premiumPreviewStatus) {
                case PremiumPreviewStatus.New:
                    switch (currentUI) {
                        case 'Callout':
                            return URL_COUNT_BASED_NEW_CALLOUT;
                        case 'ContexualCard':
                            return URL_COUNT_BASED__CONTEXUAL_CARD;
                        default:
                            assertNever(currentUI);
                    }
                    break;

                case PremiumPreviewStatus.Activated:
                    switch (currentUI) {
                        case 'Callout':
                            return URL_COUNT_BASED_ACTIVE_CALLOUT;
                        case 'ContexualCard':
                            return URL_COUNT_BASED__CONTEXUAL_CARD;
                        default:
                            assertNever(currentUI);
                    }
                    break;

                case PremiumPreviewStatus.Expired:
                    switch (currentUI) {
                        case 'Callout':
                            return URL_COUNT_BASED_EXPIRED_CALLOUT;
                        case 'ContexualCard':
                            return URL_COUNT_BASED__CONTEXUAL_CARD;
                        default:
                            assertNever(currentUI);
                    }
                    break;

                case PremiumPreviewStatus.Unknown:
                    break;

                default:
                    assertNever(premiumPreviewStatus);
            }
            break;
        case PremiumPreviewType.TimeAndCountCombined:
            switch (premiumPreviewStatus) {
                case PremiumPreviewStatus.New:
                    switch (currentUI) {
                        case 'Callout':
                            return URL_COMBO_NEW_CALLOUT;
                        case 'ContexualCard':
                            return URL_COMBO_CONTEXUAL_CARD;
                        default:
                            assertNever(currentUI);
                    }
                    break;

                case PremiumPreviewStatus.Activated:
                    switch (currentUI) {
                        case 'Callout':
                            return URL_COMBO_ACTIVE_CALLOUT;
                        case 'ContexualCard':
                            return URL_COMBO_CONTEXUAL_CARD;
                        default:
                            assertNever(currentUI);
                    }
                    break;

                case PremiumPreviewStatus.Expired:
                    switch (currentUI) {
                        case 'Callout':
                            return URL_COMBO_EXPIRED_CALLOUT;
                        case 'ContexualCard':
                            return URL_COMBO_CONTEXUAL_CARD;
                        default:
                            assertNever(currentUI);
                    }
                    break;

                case PremiumPreviewStatus.Unknown:
                    break;

                default:
                    assertNever(premiumPreviewStatus);
            }
            break;
        case PremiumPreviewType.BasicSkittle:
            switch (currentUI) {
                case 'Callout':
                    return URL_BASIC_SKITTLE_CALLOUT;
                case 'ContexualCard':
                    return isSpelling
                        ? URL_BASIC_SKITTLE_CONTEXUAL_CARD_SPELLING
                        : URL_BASIC_SKITTLE_CONTEXUAL_CARD_GRAMMAR;
                default:
                    assertNever(currentUI);
            }
            break;

        case PremiumPreviewType.None:
            switch (currentUI) {
                case 'Callout':
                    return '';
                case 'ContexualCard':
                    return isSpelling
                        ? URL_CONTROL_CONTEXUAL_CARD_SPELLING
                        : URL_CONTROL_CONTEXUAL_CARD_GRAMMAR;
                default:
                    assertNever(currentUI);
            }
            break;

        default:
            assertNever(premiumPreviewType);
    }
    return '';
}
